import {
  SET_TOKEN_VALIDATION_STATE,
  FILL_AUTH_SERVICE_POINT_DATA,
  TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA,
  SET_STATE_FOR_WAITING_FOR_AUTH_SERVICE_POINT_DATA,
  SET_AFTER_AUTHORIZATION_URL,
  SET_FORM_TYPE,
  SET_QR_CODE,
  SET_LOGIN_TOKEN,
  SET_FORM_PARAMS,
  SET_OTP_STAMP,
  SET_BLOCK_TIME,
} from './mutations-types';

export default {
  [FILL_AUTH_SERVICE_POINT_DATA](state, payload) {
    const _state = state;
    _state.params = payload.params;
    _state.initialParams = payload.params;
    _state.platform_url = payload.platform_url;
    _state.type = payload.type;
    _state.gateway = payload.gateway;
  },

  [SET_TOKEN_VALIDATION_STATE](state, payload) {
    const _state = state;
    _state.tokenIsValid = payload.isValid;
  },

  [TOGGLE_WAITING_FOR_AUTH_SERVICE_POINT_DATA](state) {
    const _state = state;
    _state.isWaitingForAuthServicePointData = !_state.isWaitingForAuthServicePointData;
  },

  [SET_STATE_FOR_WAITING_FOR_AUTH_SERVICE_POINT_DATA](state, payload) {
    const _state = state;
    _state.isWaitingForAuthServicePointData = payload;
  },

  [SET_AFTER_AUTHORIZATION_URL](state, payload) {
    const _state = state;
    _state.afterAuthorizationUrl = payload.url;
  },

  [SET_FORM_TYPE](state, payload) {
    const _state = state;
    _state.type = payload;
  },
  [SET_QR_CODE](state, payload) {
    const _state = state;
    _state.qrCode = payload;
  },
  [SET_LOGIN_TOKEN](state, payload) {
    const _state = state;
    _state.loginToken = payload;
  },
  [SET_FORM_PARAMS](state, payload) {
    const _state = state;
    _state.params = payload;
  },
  [SET_OTP_STAMP](state, payload) {
    const _state = state;
    _state.otpStamp = payload;
  },
  [SET_BLOCK_TIME](state, payload) {
    const _state = state;
    _state.unlockStamp = payload;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/authServicesPoints/mutations.js